import * as ROLES from '../../constants/roles';

/**
 * Get a human readable string of a role
 *
 * @param {string} role The role
 * @returns {string} The hrs
 */
// eslint-disable-next-line import/prefer-default-export
export const getRoleLabel = (role) => {
  switch (role) {
    case ROLES.ROLE_ADMINISTRATOR:
      return 'Amministratore';
    case ROLES.ROLE_NEONATOLOGIST_BIRTH_CENTRE:
      return 'Neonatologo centro nascite';
    case ROLES.ROLE_NURSE_BIRTH_CENTRE:
      return 'Infermiere centro nascite';
    case ROLES.ROLE_NEONATOLOGIST_NC:
      return 'Neonatologo centro TIN';
    case ROLES.ROLE_NURSE_NC:
      return 'Infermiere centro TIN';
    case ROLES.ROLE_GYNECOLOGIST:
      return 'Ginecologo';
    case ROLES.ROLE_OBSTETRICIAN:
      return 'Ostetrico';
    case ROLES.ROLE_REGIONAL_SUPERVISOR:
      return 'Supervisore';
    case ROLES.ROLE_AUDITIVE_SUPERVISOR:
      return 'Supervisore Uditivo';
    case ROLES.ROLE_AUDITIVE_LEVEL_2:
      return 'Audiologico II Livello';
    case ROLES.ROLE_AUDITIVE_LEVEL_3:
      return 'Audiologico III Livello';
    case ROLES.ROLE_OPHTHALMOLOGY_LEVEL_2:
      return 'Oftalmologico II Livello';
    case ROLES.ROLE_OPHTHALMOLOGY_LEVEL_3:
      return 'Oftalmologico III Livello';
    case ROLES.ROLE_CEDAP_MANAGER:
      return 'Gestore CeDAP';
    case ROLES.ROLE_CEDAP_MANAGER_READ_ONLY:
      return 'Gestore CeDAP Read Only';
    case ROLES.ROLE_REFERENT_CONGENITAL_MALFORMATIONS:
      return 'Referente regionale malformazioni';
    case ROLES.ROLE_LAB:
      return 'Laboratorio';
    case ROLES.ROLE_BE20:
      return 'BE 20';
    case ROLES.ROLE_LHC_MANAGER:
      return 'Gestore ASL';
    case ROLES.ROLE_FACILITY_MANAGER:
      return 'Referente Aziendale';
    case ROLES.ROLE_PEDIATRIC_CENTRE_RARE_METABOLIC_DISEASES:
    case ROLES.ROLE_PEDIATRIC_CENTRE_HEREDITARY_METABOLIC_DISEASES:
      return 'Pediatra';
    case ROLES.ROLE_SUPPORT:
      return 'Supporto';
    default:
      return '-';
  }
};

/**
 * Retrieve required fields to complete hcp profile
 *
 * @param {boolean} isNotPhysician
 * @returns {Array<string>}
 */
export const getRequiredHcpFields = (isNotPhysician) => {
  const baseFields = [
    'title',
    'name',
    'surname',
    'fiscalCode',
    'birthdate',
    'profession',
    'gender',
  ];
  if (!isNotPhysician) baseFields.push('registryNumber');
  return baseFields;
};
